import React, { Fragment } from "react";
import Footer from "../../footer";
import CasePart from "./CasePart.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import { Prompt, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setNameCase, handleSelectTypeCasePilgan, handleSelectTypeCaseMenjodohkan, handleSelectTypeCaseEssay, addCasePart, deleteItem, deleteScheduleActive, postRequestSuccess, handleSelectCourse, handleSelectClass, loadParsedExamData } from "../../../store/actions/index";
import axiosInstance from "../../../store/services/AxiosService";
import Ball from "../../../assets/Ball.svg";
import SelectCourse from "../component/SelectCourseComponent";
import SelectClass from "../component/SelectClassComponent.js";
import BankSoalModal from "../component/BankSoalModal.jsx";


class Exam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alertSubmit: null,
            taskDone: false,
            listCourse: null,
            caseStillEmpty: false,
            classId: null,
            courseId: null,
            listKd: null,
            listClass: null,
            // TODO: New state for drag and drop file
            uploadedFile: null,
            isDragOver: false,
            fileError: null,
            isLoadingFile: false,
            fileProcessSuccess: false,
            tipePenilaian: 'CP', // default
            showBankSoalModal: false,
        };


        // TODO: Bind all drag and drop methods
        this.handleDragEnter = this.handleDragEnter.bind(this);
        this.handleDragLeave = this.handleDragLeave.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.handleFileSelect = this.handleFileSelect.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.processFile = this.processFile.bind(this);
        this.getFileIcon = this.getFileIcon.bind(this);
        this.formatFileSize = this.formatFileSize.bind(this);
        this.handleLoadFile = this.handleLoadFile.bind(this);
        this.componentUploadSoalNew = this.componentUploadSoalNew.bind(this);
    }

    componentDidMount() {
        this.fetchCptpSetting();
    }

    componentDidUpdate(prevProps) {
        // Retry fetch when schoolId becomes available
        const prevSchoolId = prevProps.schoolId || (prevProps.cases && prevProps.cases.school_id);
        const currentSchoolId = this.props.schoolId || (this.props.cases && this.props.cases.school_id);
        if (!prevSchoolId && currentSchoolId) {
            this.fetchCptpSetting();
        }

        // Fetch KD list if course or class changes (for Soal Baru)
        if (
            (prevProps.cases?.course_id !== this.props.cases?.course_id ||
             prevProps.cases?.class_grade_id !== this.props.cases?.class_grade_id) &&
            this.props.cases?.course_id &&
            this.props.cases?.class_grade_id &&
            currentSchoolId
        ) {
            let url = `/kompetensi-dasar/course/${this.props.cases.course_id}/class/${this.props.cases.class_grade_id}/school/${currentSchoolId}`;
            axiosInstance.get(url).then(res => {
                this.setState({ listKd: res.data });
            }).catch(err => {
                console.warn("Failed to fetch KD list:", err);
            });
        }
    }

    fetchCptpSetting() {
        const school_id = this.props.schoolId || (this.props.cases && this.props.cases.school_id);
        if (!school_id) {
            console.warn('fetchCptpSetting: school_id belum tersedia');
            return;
        }
        const url = `/kompetensi-dasar/cptp-setting/school/${school_id}`;
        axiosInstance
            .get(url)
            .then((r) => {
                console.log('CP/TP Setting response:', r.data);
                this.setState({ tipePenilaian: r.data.tipe_penilaian || 'CP' });
            })
            .catch((error) => {
                this.setState({ tipePenilaian: 'CP' });
                console.warn(`Fetch CP/TP setting gagal: ${error.message}`);
            });
    }

    // TODO: Drag and Drop Methods
    handleDragEnter(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragOver: true });
    }

    handleDragLeave(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragOver: false });
    }

    handleDragOver(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragOver: true });
    }

    handleDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragOver: false });

        const files = e.dataTransfer.files;
        if (files.length > 0) {
            this.processFile(files[0]);
        }
    }

    handleFileSelect(e) {
        const file = e.target.files[0];
        if (file) {
            this.processFile(file);
        }
    }

    processFile(file) {
        // TODO: Check file type
        const allowedTypes = [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ];

        if (!allowedTypes.includes(file.type)) {
            this.setState({
                fileError: 'Only PDF and Word documents are allowed',
                uploadedFile: null
            });
            return;
        }

        // Check file size (limit to 10MB)
        if (file.size > 10 * 1024 * 1024) {
            this.setState({
                fileError: 'File size must be less than 10MB',
                uploadedFile: null
            });
            return;
        }

        this.setState({
            uploadedFile: file,
            fileError: null
        });
    }

    removeFile() {
        this.setState({
            uploadedFile: null,
            fileError: null
        });
    }

    getFileIcon(fileType) {
        if (fileType === 'application/pdf') {
            return 'mdi-file-pdf';
        } else if (fileType.includes('word')) {
            return 'mdi-file-word';
        }
        return 'mdi-file-document';
    }

    formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    async handleLoadFile() {
        if (!this.state.uploadedFile) {
            this.setState({
                fileError: 'Please select a file first'
            });
            return;
        }

        this.setState({
            isLoadingFile: true,
            fileError: null
        });

        try {
            const formData = new FormData();
            formData.append('file', this.state.uploadedFile);

            const baseURL = process.env.REACT_APP_BACKEND_URL2 || process.env.REACT_APP_BACKEND_URL || 'https://api.soalmhs.id/api';
            const response = await fetch(`${baseURL}/parse-exam-improved`, {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                throw new Error('Failed to parse file');
            }

            const result = await response.json();

            if (result.success) {
                // Dispatch action to load parsed data into Redux
                this.props.loadParsedExamData(result);

                this.setState({
                    isLoadingFile: false,
                    fileProcessSuccess: true,
                    uploadedFile: null
                });

                // Show success alert
                const alertSuccess = () => (
                    <SweetAlert
                        success
                        title="Berhasil!"
                        onConfirm={() => this.setState({ alertSubmit: null })}
                    >
                        File soal berhasil dimuat! Total: {result.stats.total_questions} pertanyaan
                    </SweetAlert>
                );
                this.setState({ alertSubmit: alertSuccess() });
            } else {
                throw new Error('Parse failed');
            }
        } catch (error) {
            this.setState({
                isLoadingFile: false,
                fileError: `Error: ${error.message}. Pastikan API dapat diakses`
            });
        }
    }

    // END TODO

    addItem(e) {
        e.preventDefault();
        this.props.addCasePart(this.props.currentItemTypeCase, this.props.cases?.name);
    }

    deleteItem(key) {
        var removeIndex = this.props.casePart
            .map(function (item) {
                return item.key;
            })
            .indexOf(key);
        this.props.deleteCasePart(removeIndex);
    }

    handleSelectTypeCase(text) {
        if (text === "uraian") {
            this.props.handleSelectTypeCaseEssay(text, null);
        } else if (text === "menjodohkan") {
            this.props.handleSelectTypeCaseMenjodohkan(text, null);
        } else {
            this.props.handleSelectTypeCasePilgan(text, null);
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        
        let errorMessages = [];
        const isCptpOptional = this.state.listKd && this.state.listKd.length === 0;

        try {
            if (this.props.casePart) {
                Object.values(this.props.casePart).forEach((element, partIndex) => {
                    const partName = element.name || `Bagian ${partIndex + 1}`;
                    
                    if (Number(element.score_weight) === 0 || !element.score_weight) {
                        errorMessages.push(`<b>${partName}</b>: Bobot nilai masih 0.`);
                    }

                    if (element.case_questions) {
                        Object.values(element.case_questions).forEach((item, qIndex) => {
                            const qNumber = qIndex + 1;
                            
                            if (!item.question || item.question.trim() === "") {
                                errorMessages.push(`<b>${partName} - Soal No. ${qNumber}</b>: Teks pertanyaan kosong.`);
                            }
                            
                            if (!isCptpOptional) {
                                if (!item.kd_id) {
                                    errorMessages.push(`<b>${partName} - Soal No. ${qNumber}</b>: Capaian Pembelajaran (CP) belum dipilih.`);
                                }
                                if (this.state.tipePenilaian === 'TP' && !item.kd_unit_id) {
                                    errorMessages.push(`<b>${partName} - Soal No. ${qNumber}</b>: Tujuan Pembelajaran (TP) belum dipilih.`);
                                }
                            }
                            
                            if (element.type_name === "pilihan ganda" || element.type_name === "pilihan ganda benar salah" || element.type_name === "pilihan ganda kompleks") {
                                let hasEmptyChoice = false;
                                let hasCorrectAnswer = false;
                                
                                if (item.case_choices) {
                                    Object.values(item.case_choices).forEach((choice) => {
                                        if (!choice.value || String(choice.value).trim() === "") {
                                            hasEmptyChoice = true;
                                        }
                                        if (choice.is_correct === true || choice.is_correct === "true" || choice.is_correct === 1 || choice.is_correct === "1") {
                                            hasCorrectAnswer = true;
                                        }
                                    });
                                }
                                
                                if (hasEmptyChoice) {
                                    errorMessages.push(`<b>${partName} - Soal No. ${qNumber}</b>: Terdapat opsi jawaban yang kosong.`);
                                }
                                if (!hasCorrectAnswer) {
                                    errorMessages.push(`<b>${partName} - Soal No. ${qNumber}</b>: Kunci jawaban belum dipilih.`);
                                }
                            }
                        });
                    }
                });
            }
        } catch (e) {
            console.error("Validation error:", e);
            errorMessages.push("Terjadi kesalahan saat validasi data soal.");
        }

        if (errorMessages.length > 0) {
            const errorList = (
                <div style={{ textAlign: "left", maxHeight: "300px", overflowY: "auto", fontSize: "14px", marginTop: "15px" }}>
                    <ul style={{ paddingLeft: "20px", margin: 0 }}>
                        {errorMessages.map((msg, index) => (
                            <li key={index} dangerouslySetInnerHTML={{ __html: msg }} style={{ marginBottom: "5px" }}></li>
                        ))}
                    </ul>
                </div>
            );

            const alertValidationError = () => (
                <SweetAlert 
                    warning 
                    title="Oops! Ada yang terlewat" 
                    onConfirm={() => this.setState({ alertSubmit: null })} 
                    onCancel={() => this.setState({ alertSubmit: null })}
                >
                    <p style={{ margin: 0 }}>Mohon lengkapi bagian berikut sebelum menyimpan:</p>
                    {errorList}
                </SweetAlert>
            );

            this.setState({
                alertSubmit: alertValidationError(),
            });
        } else {
            const getAlert = () => (
                <SweetAlert custom showCancel showCloseButton confirmBtnText="Ya" cancelBtnText="Tidak" confirmBtnBsStyle="primary" cancelBtnBsStyle="light" title="Apakah Anda Yakin ?" onConfirm={() => this.submitExam()} onCancel={() => this.setState({ alertSubmit: null })}>
                    Simpan Soal
                </SweetAlert>
            );
            
            this.setState({
                alertSubmit: getAlert(),
            });
        }
    }

    async submitExam() {
        this.setState({ alertSubmit: null });
        const url = "/cases/createExam";

        // Get class_grade_id from route params OR from Redux state
        const { class_grade_id } = this.props.match.params;
        const finalClassGradeId = class_grade_id || this.props.cases?.class_grade_id;

        const partsToPost = Object.values(this.props.casePart || []).map(p => {
            if (p.type_name === "menjodohkan") {
                return { ...p, random_choice_order: 1 };
            }
            return p;
        });

        const dataToPost = {
            cases: { ...this.props.cases, school_id: this.props.cases?.school_id || this.props.schoolId, class_grade_id: Number(finalClassGradeId), class_label: this.props.cases?.class_label || this.props.scheduleSelected?.className || null },
            case_parts: partsToPost,
            schedules: this.props.schedules,
        };

        axiosInstance
            .post(url, dataToPost)
            .then((response) => {
                this.props.postRequestSuccess();
                this.handleSuccessSubmit();
            })
            .catch((error) => {
                if (error.response?.status === 500) {
                    this.handleFailureSubmit("Terdapat data internal server yang bermasalah. Harap coba beberapa saat lagi.", true);
                } else if (error.response?.status === 422 && error.response?.data?.errors) {
                    let errMsg = "Data yang dikirim tidak sesuai (Ditolak Server):<br/><ul style='text-align: left; padding-left: 20px; font-size: 14px; margin-top: 10px;'>";
                    Object.values(error.response.data.errors).forEach(errArr => {
                        errMsg += `<li>${errArr[0]}</li>`;
                    });
                    errMsg += "</ul>";
                    this.handleFailureSubmit(errMsg);
                } else if (error.response?.data?.message) {
                    this.handleFailureSubmit(error.response.data.message);
                } else {
                    this.handleFailureSubmit(error.message);
                }
            });
    }

    handleSuccessSubmit() {
        const alertSuccess = () => (
            <SweetAlert
                success
                title="Berhasil !"
                onConfirm={() =>
                    this.setState({
                        alertSubmit: null,
                        taskDone: true,
                    })
                }
            >
                Soal berhasil disimpan !
            </SweetAlert>
        );
        this.setState({
            alertSubmit: alertSuccess(),
        });
    }

    handleFailureSubmit(errorMessage, isRequired = false) {
        if (isRequired) {
            this.setState({
                caseStillEmpty: true,
            });
        }

        const alertFailure = () => (
            <SweetAlert warning title="Proses Gagal !" onConfirm={() => this.setState({ alertSubmit: null })} onCancel={() => this.setState({ alertSubmit: null })}>
                <div dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
            </SweetAlert>
        );
        this.setState({
            alertSubmit: alertFailure(),
        });
    }

    componentDidMount() {
        const { class_grade_id, course_id } = this.props.match.params;

        if (this.props.makeCaseBySchedule === false) {
            // NEW CASE FLOW: Fetch all courses and classes for selection
            const isUserAdmin = [1, 6, 7].includes(Number(this.props.roleId));
            const queryParams = `?is_admin=${isUserAdmin}&role_id=${this.props.roleId}&teacher_id=${this.props.userId}`;

            axiosInstance.get(`/courses/teacher/${this.props.userId}/school/${this.props.schoolId}${queryParams}`)
                .then((res) => {
                    const list = res.data || [];
                    const formattedCourses = Object.values(list).map((item) => ({
                        value: item.course_id,
                        label: item.course_name,
                    }));
                    this.setState({ listCourse: formattedCourses });
                })
                .catch((err) => {
                    console.warn("Failed to fetch courses:", err);
                    this.setState({ listCourse: [] });
                });

            axiosInstance.get(`/classes/teacher/${this.props.userId}/school/${this.props.schoolId}${queryParams}`)
                .then((res) => {
                    const list = res.data || [];
                    const formattedClasses = Object.values(list).map((item) => ({
                        value: item.class_id,
                        class_id: item.class_id,
                        class_grade_id: item.class_grade_id,
                        label: item.class_label,
                    }));
                    formattedClasses.sort((a, b) => {
                        const gradeA = a.class_grade_id ?? 0;
                        const gradeB = b.class_grade_id ?? 0;
                        if (gradeA !== gradeB) {
                            return gradeA - gradeB;
                        }
                        return (a.label || "").localeCompare(b.label || "", undefined, { numeric: true, sensitivity: 'base' });
                    });
                    this.setState({ listClass: formattedClasses });
                })
                .catch((err) => {
                    console.warn("Failed to fetch classes:", err);
                    this.setState({ listClass: [] });
                });
        } else if (class_grade_id !== undefined && course_id !== undefined) {
            // SCHEDULE-BASED FLOW: Fetch KD for specific class and course
            let url = `/kompetensi-dasar/course/${course_id}/class/${class_grade_id}/school/${this.props.schoolId}`;
            if (this.props.match && this.props.match.params && this.props.match.params.schedule_id) {
                url += `?schedule_id=${this.props.match.params.schedule_id}`;
            }
            axiosInstance.get(url)
                .then((res) => {
                    const list = res.data;
                    this.setState({ listKd: list });
                });
        }
    }

    handleMaxScore(value) {
        this.setState({ maxScore: value });
    }

    componentWillUnmount() {
        this.props.deleteScheduleActive();
        if (this.state.taskDone === true) {
            localStorage.removeItem("reduxState");
        }
    }

    componentUploadSoalNew() {
        return (
            <>
                {/* TODO: Drag and Drop File Section */}
                <div className="form-group mb-4">
                    <p className="h4">Upload File Soal (Opsional):</p>
                    <div
                        className={`drag-drop-zone ${this.state.isDragOver ? 'drag-over' : ''}`}
                        onDragEnter={this.handleDragEnter}
                        onDragLeave={this.handleDragLeave}
                        onDragOver={this.handleDragOver}
                        onDrop={this.handleDrop}
                        style={{
                            border: '2px dashed #ccc',
                            borderRadius: '8px',
                            padding: '20px',
                            textAlign: 'center',
                            backgroundColor: this.state.isDragOver ? '#f8f9fa' : '#ffffff',
                            borderColor: this.state.isDragOver ? '#007bff' : '#ccc',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                        onClick={() => document.getElementById('fileInput2').click()}
                    >
                        {!this.state.uploadedFile ? (
                            <div>
                                <i className="mdi mdi-cloud-upload" style={{ fontSize: '48px', color: '#6c757d' }}></i>
                                <p className="mb-2">Drag and drop file di sini atau klik untuk memilih</p>
                                <small className="text-muted">Hanya file PDF dan Word (.doc, .docx) yang diperbolehkan (maksimal 10MB)</small>
                            </div>
                        ) : (
                            <div className="uploaded-file-info">
                                <div className="d-flex align-items-center justify-content-center">
                                    <i className={`mdi ${this.getFileIcon(this.state.uploadedFile.type)} mr-2`} style={{ fontSize: '24px', color: '#28a745' }}></i>
                                    <div>
                                        <p className="mb-1 font-weight-bold">{this.state.uploadedFile.name}</p>
                                        <small className="text-muted">{this.formatFileSize(this.state.uploadedFile.size)}</small>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm ml-3"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.removeFile();
                                        }}
                                    >
                                        <i className="mdi mdi-delete"></i>
                                    </button>
                                </div>
                            </div>
                        )}
                        <input
                            id="fileInput2"
                            type="file"
                            accept=".pdf,.doc,.docx"
                            onChange={this.handleFileSelect}
                            style={{ display: 'none' }}
                        />
                    </div>
                    {this.state.fileError && (
                        <div className="alert alert-danger mt-2" role="alert">
                            <i className="mdi mdi-alert-circle mr-2"></i>
                            {this.state.fileError}
                        </div>
                    )}
                    {this.state.uploadedFile && (
                        <button
                            type="button"
                            className="btn btn-primary mt-2"
                            onClick={this.handleLoadFile}
                            disabled={this.state.isLoadingFile}
                        >
                            {this.state.isLoadingFile ? (
                                <>
                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                    Memproses...
                                </>
                            ) : (
                                <>
                                    <i className="mdi mdi-upload mr-2"></i>
                                    Muat Soal dari File
                                </>
                            )}
                        </button>
                    )}
                    <button
                        type="button"
                        className="btn btn-outline-info mt-2 ml-2"
                        onClick={() => this.setState({ showBankSoalModal: true })}
                    >
                        <i className="mdi mdi-cloud-download mr-2"></i>
                        Ambil dari Bank Soal
                    </button>
                </div>
            </>
        )
    }

    // END TODO

    render() {
        if (this.state.taskDone === true) {
            return <Redirect to="/" />;
        }

        return (
            <Fragment>
                <Prompt
                    message={JSON.stringify({
                        confirmText: "Tetap Keluar",
                        messageText: "Apakah Anda akan keluar? Simpan Terlebih Dahulu",
                        cancelText: "Batal",
                    })}
                />
                <div className="main-panel">
                    <div className="content-wrapper">
                        {this.state.listCourse === null && this.props.makeCaseBySchedule === false && this.props.casePart.length === 0 ? (
                            <div className="d-flex justify-content-center">
                                <img src={Ball} className="img-fluid" alt="" />
                            </div>
                        ) : this.props.makeCaseBySchedule === true ? (
                            // make soal from dashoboard
                            <div className="make-soal col-12">
                                <div className="page-header">
                                    <h3 className="page-title">
                                        <span className="page-title-icon bg-gradient-primary text-white mr-2">
                                            <i className="mdi mdi-lead-pencil"></i>
                                        </span>
                                        Buat Soal
                                    </h3>
                                </div>
                                <div className="info-panel">
                                    <div className="d-flex justify-content-start">
                                        <h1 className="m-2">{this.props.scheduleSelected.courseName}</h1>
                                        <label className="badge badge-gradient-danger align-self-center m-2">{this.props.scheduleSelected.typeCase}</label>
                                    </div>
                                    <div className="d-flex justify-content-start">
                                        <h5 className="m-2">{this.props.scheduleSelected.className}</h5>
                                        <h5 className="m-2">{this.props.scheduleSelected.date}</h5>
                                        <h5 className="m-2">{this.props.scheduleSelected.time}</h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 grid-margin">
                                        <div className="card custom-card-shadow">
                                            <div className="card-body">
                                                <h4 className="card-title">
                                                    Klik <strong>"Tambah"</strong> untuk menambahkan soal
                                                </h4>
                                                <h6 className="card-subtitle mb-2 text-muted">
                                                    <i>Catatan: Masukan nama soal terlebih dahulu</i>
                                                </h6>

                                                {this.componentUploadSoalNew()}

                                                <div className="question-panel">
                                                    <form onSubmit={(e) => this.handleSubmit(e)}>

                                                        <div className="form-group">
                                                            <p className="h4">Nama Soal:</p>
                                                            <input id="examName" type="text" className="form-control inputQuestion darkLine" style={{ fontSize: "1rem" }} placeholder="Masukan Nama Soal Terlebih Dahulu" value={this.props.cases?.name || ''} onChange={this.props.inputChanged} required />
                                                        </div>
                                                        <div className="dropdown-divider"></div>

                                                        {this.props.casePart.map((member, index) => (
                                                            <Fragment key={index}>
                                                                <div>
                                                                    <CasePart index={index} keyID={member.key} noBab={index + 1} typeCase={member.type_name} stillEmpty={this.state.caseStillEmpty} handleDeletePartCase={this.deleteItem.bind(this)} handleMaxScore={this.handleMaxScore.bind(this)} tipePenilaian={this.state.tipePenilaian} />
                                                                </div>
                                                                <div className="dropdown-divider mt-5 mb-5 darkLine"></div>
                                                            </Fragment>
                                                        ))}

                                                        <div className="form-group mt-2 form-group-tipe-soal">
                                                            <p className="h4">Tambah Tipe Soal</p>
                                                            <div className="d-flex flex-wrap">
                                                                <select
                                                                    value={this.props.currentItemTypeCase.type_name}
                                                                    className="custom-select custom-select-tipe-soal mr-sm-2 darkLine"
                                                                    id="chooseCasePart"
                                                                    onChange={(e) => this.handleSelectTypeCase(e.target.value)}
                                                                    disabled={this.props.cases?.name ? null : true}
                                                                >
                                                                    <option value="">Pilih Tipe Soal</option>
                                                                    <option value="pilihan ganda">Pilihan Ganda</option>
                                                                    <option value="pilihan ganda benar salah">Pilihan Ganda Benar Salah</option>
                                                                    <option value="uraian">Uraian</option>
                                                                    <option value="pilihan ganda kompleks">Pilihan Ganda Kompleks</option>
                                                                    <option value="isian singkat">Isian Singkat</option>
                                                                    <option value="menjodohkan">Menjodohkan</option>
                                                                </select>

                                                                <button className="btn btn-gradient-primary mr-2" onClick={this.addItem.bind(this)} disabled={this.props.currentItemTypeCase.type_name === "" ? true : false}>
                                                                    Tambah
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {this.props.casePart.length > 0 && (
                                                            <div className="mt-4">
                                                                <button type="submit" className="btn btn-success btn-lg btn-block">
                                                                    Simpan Soal
                                                                </button>
                                                                {this.state.alertSubmit}
                                                            </div>
                                                        )}
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            // make soal new
                            <div className="make-soal col-12">
                                <div className="page-header">
                                    <h3 className="page-title">
                                        <span className="page-title-icon bg-gradient-primary text-white mr-2">
                                            <i className="mdi mdi-lead-pencil"></i>
                                        </span>
                                        Buat Soal
                                    </h3>
                                </div>
                                <div className="info-panel">
                                    <div className="d-flex justify-content-start">
                                        <h1 className="m-2">Soal Baru</h1>
                                        <label className="badge badge-gradient-danger align-self-center m-2">Soal Baru</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 grid-margin">
                                        <div className="card custom-card-shadow">
                                            <div className="card-body">
                                                <h4 className="card-title">
                                                    Klik <strong>"Tambah"</strong> untuk menambahkan soal
                                                </h4>
                                                <h6 className="card-subtitle mb-2 text-muted">
                                                    <i>Catatan: Masukan nama soal terlebih dahulu</i>
                                                </h6>

                                                {this.componentUploadSoalNew()}

                                                <div className="question-panel">
                                                    <form onSubmit={(e) => this.handleSubmit(e)}>
                                                        {
                                                            this.state.listCourse === null ? (
                                                                <div className="d-flex justify-content-center">
                                                                    <img src={Ball} className="img-fluid" alt="loading" />
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <div className="form-group">
                                                                        <p className="h4">Pilih Kelas:</p>
                                                                        <SelectClass listClass={this.state.listClass} defaultValue={this.props.cases?.class_id || this.props.cases?.class_grade_id} onSelectClass={(e) => this.props.handleSelectClass(e)} />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <p className="h4">Pilih Mata Pelajaran:</p>
                                                                        <SelectCourse listCourse={this.state.listCourse} onSelectCourse={(e) => this.props.handleSelectCourse(e)} />
                                                                    </div>
                                                                </>
                                                            )
                                                        }

                                                        <div className="form-group">
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <p className="h4">Nama Soal:</p>
                                                                {/* <Link to="/question-weights" className="btn btn-sm btn-outline-primary" target="_blank">
                                                                    <i className="mdi mdi-settings mr-1"></i> Pengaturan Bobot
                                                                </Link> */}
                                                            </div>
                                                            <input id="examName" type="text" className="form-control inputQuestion darkLine" style={{ fontSize: "1rem" }} placeholder="Masukan Nama Soal Terlebih Dahulu" value={this.props.cases?.name || ''} onChange={this.props.inputChanged} required />
                                                        </div>
                                                        <div className="dropdown-divider"></div>

                                                        {this.props.casePart.map((member, index) => (
                                                            <Fragment key={index}>
                                                                <div>
                                                                    <CasePart index={index} keyID={member.key} noBab={index + 1} typeCase={member.type_name} stillEmpty={this.state.caseStillEmpty} handleDeletePartCase={this.deleteItem.bind(this)} handleMaxScore={this.handleMaxScore.bind(this)} tipePenilaian={this.state.tipePenilaian} />
                                                                </div>
                                                                <div className="dropdown-divider mt-5 mb-5 darkLine"></div>
                                                            </Fragment>
                                                        ))}

                                                        <div className="form-group form-group-tipe-soal mt-2">
                                                            <p className="h4">Tambah Tipe Soal</p>
                                                            <div className="d-flex flex-wrap">
                                                                <select
                                                                    value={this.props.currentItemTypeCase.type_name}
                                                                    className="custom-select custom-select-tipe-soal mr-sm-2 darkLine"
                                                                    id="chooseCasePart"
                                                                    onChange={(e) => this.handleSelectTypeCase(e.target.value)}
                                                                    disabled={this.props.cases?.name ? null : true}
                                                                >
                                                                    <option value="">Pilih Tipe Soal</option>
                                                                    <option value="pilihan ganda">Pilihan Ganda</option>
                                                                    <option value="pilihan ganda benar salah">Pilihan Ganda Benar Salah</option>
                                                                    <option value="uraian">Uraian</option>
                                                                    <option value="pilihan ganda kompleks">Pilihan Ganda Kompleks</option>
                                                                    <option value="isian singkat">Isian Singkat</option>
                                                                    <option value="menjodohkan">Menjodohkan</option>
                                                                </select>

                                                                <button className="btn btn-gradient-primary mr-2" onClick={this.addItem.bind(this)} disabled={this.props.currentItemTypeCase.type_name === "" ? true : false}>
                                                                    Tambah
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {this.props.casePart.length > 0 && (
                                                            <div className="mt-4">
                                                                <button type="submit" className="btn btn-success btn-lg btn-block">
                                                                    Simpan Soal
                                                                </button>
                                                                {this.state.alertSubmit}
                                                            </div>
                                                        )}
                                                    </form>
                                                </div>
                                                <Footer />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                
                <BankSoalModal 
                    show={this.state.showBankSoalModal} 
                    onHide={() => this.setState({ showBankSoalModal: false })} 
                />
            </Fragment>
        );
    }
}

const mapToStateToProps = (state) => {
    console.log(state);
    return {
        currentItemTypeCase: state.Exam.currentItemCase,
        casePart: state.Exam.case_part,
        scheduleSelected: state.Exam.scheduleSelected,
        schedules: state.Exam.schedules,
        cases: state.Exam.cases,
        makeCaseBySchedule: state.Exam.makeCaseBySchedule,
        userId: state.User.dataTeacher?.user?.data_employee?.employee_id || state.User.dataTeacher?.user?.user_id,
        roleId: state.User.dataTeacher?.user?.role_id,
        schoolId: state.User.dataSchool?.value,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        inputChanged: (event) => dispatch(setNameCase(event.target.value)),
        handleSelectTypeCaseEssay: (text) => dispatch(handleSelectTypeCaseEssay(text, null)),
        handleSelectTypeCasePilgan: (text) => dispatch(handleSelectTypeCasePilgan(text, null)),
        handleSelectTypeCaseMenjodohkan: (text) => dispatch(handleSelectTypeCaseMenjodohkan(text, null)),
        addCasePart: (casePart, nameExam) => dispatch(addCasePart(casePart, nameExam)),
        deleteCasePart: (part) => dispatch(deleteItem(part)),
        deleteScheduleActive: () => dispatch(deleteScheduleActive()),
        postRequestSuccess: () => dispatch(postRequestSuccess()),
        handleSelectCourse: (courseSelected) => dispatch(handleSelectCourse(courseSelected)),
        handleSelectClass: (classSelected) => dispatch(handleSelectClass(classSelected)),
        loadParsedExamData: (parsedData) => dispatch(loadParsedExamData(parsedData)),
    };
};

export default connect(mapToStateToProps, mapDispatchToProps)(withRouter(Exam));
